import BaseComponent from "@js/components/base_component.jsx";
import TwoFactor from "@js/components/eui/users/twofactor.jsx";
import PasswordRequirements from "@js/components/eui/users/password_requirements.jsx";

import { Modal, ModalHeader, ModalBody, ModalFooter, ModalButton } from "@js/components/eui/modal/index.js";

class EuiUsersForm extends BaseComponent {

  static defaultProps = {
    editing: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      editing_password: this.props.entity.editing_password || !this.props.entity.id,
      is_disabled: this.props.entity.is_disabled,
      downgrading_self: false,
    };
  }

  componentDidMount() {
    $("form").on("submit", this._onFormSubmit);
  }

  componentWillUnmount() {
    $("form").off("submit", this._onFormSubmit);
  }

  render() {
    return (
      <div>

        {
          this.props.entity.has_conflicting_user_mailbox && (
            <div className="alert alert-warning">
              { t("notices.engine_duplicate_mailbox_user_on_user") }
            </div>
          )
        }

        <ErrorBanner entity={ this.props.entity } />

        <Panel heading="user_details">
          <div className="form-horizontal">

            <InputField
              object={ this.props.entity }
              type="eng_user"
              field="email"
              editing={ this.props.editing }
            />

            {
              ( !this.props.editing ) ? (
                <InputField
                  object={ this.props.entity }
                  type="eng_user"
                  field="password"
                  editing={ false }
                  password={ true }
                  valueText="(not shown)"
                />
              ) : this.state.editing_password ? (
                <React.Fragment>
                  <input type="hidden" name="eng_user[editing_password]" value="1" />
                  <InputField
                    object={ this.props.entity }
                    type="eng_user"
                    field="new_password1"
                    editing={ this.props.editing }
                    password={ true }
                  />
                  <InputField
                    object={ this.props.entity }
                    type="eng_user"
                    field="new_password2"
                    editing={ this.props.editing }
                    password={ true }
                  />
                  <PasswordRequirements />
                </React.Fragment>
              ) : (
                <FieldContainer labelText="Password">
                  <a href="#" onClick={ (e) => { e.preventDefault(); this.setState({ editing_password: true }); } }>
                    Change this user's password
                  </a>
                </FieldContainer>
              )
            }

            <TwoFactor
              entity={ this.props.entity }
              library={ this.props.library }
              editing={ this.props.editing }
            />

            <CheckboxField
              name="eng_user[is_disabled]"
              label={ I18n.t("simple_form.labels.eng_user.is_disabled") }
              editing={ this.props.editing }
              checked={ this.state.is_disabled }
              onChange={ disabled => this.setState({ is_disabled: disabled }) }
            />

          </div>
        </Panel>

        <Panel heading="user_mail_class">
          <div className="form-horizontal">

            <SelectField
              field="eng_user.force_mail_class_id"
              blank="force_mail_class"
              value={ this.props.entity.force_mail_class_id }
              options={ this.props.library.mail_classes }
              editing={ this.props.editing }
              error={ this.props.entity.errors ? this.props.entity.errors.force_mail_class_id : null }
            />

          </div>
        </Panel>

        <Panel heading="user_permissions">
          <div className="form-horizontal">

            <SelectField
              field="eng_user.permission_ui"
              blank="user_permission_selection"
              value={ this.props.entity.permission_ui }
              options={ this.permissionApiAndUiOptions() }
              editing={ this.props.editing }
              error={ this.props.entity.errors ? this.props.entity.errors.permission_ui : null }
            />

            <SelectField
              field="eng_user.permission_api"
              blank="user_permission_selection"
              value={ this.props.entity.permission_api }
              options={ this.permissionApiAndUiOptions() }
              editing={ this.props.editing }
              error={ this.props.entity.errors ? this.props.entity.errors.permission_api : null }
            />

            <SelectField
              field="eng_user.permission_injection"
              blank="user_permission_selection"
              value={ this.props.entity.permission_injection }
              options={ this.permissionInjectionOptions() }
              editing={ this.props.editing }
              error={ this.props.entity.errors ? this.props.entity.errors.permission_injection : null }
            />

          </div>
        </Panel>

        {
          this.state.downgrading_self && (
            <Modal>
              <ModalHeader onCancel={ this._stopDowngradingSelf }>
                Downgrade User Permissions
              </ModalHeader>
              <ModalBody>
                This action would make it so your user account can no longer
                manage GreenArrow Engine. Are you sure you want to do this?
              </ModalBody>
              <ModalFooter>
                <ModalButton onClick={ this._stopDowngradingSelf }>{ t("buttons.cancel") }</ModalButton>
                <ModalButton onClick={ this._doFormSubmit } dangerous={ true }>{ t("buttons.continue") }</ModalButton>
              </ModalFooter>
            </Modal>
          )
        }

      </div>
    );
  }

  permissionInjectionOptions() {
    return [
      { "value": "yes",       "label": "Both SMTP and HTTP"     },
      { "value": "smtp-only", "label": "SMTP only"              },
      { "value": "http-only", "label": "HTTP only"              },
      { "value": "no",        "label": "Do not allow injection" },
    ];
  }

  permissionApiAndUiOptions() {
    return [
      { "value": "yes",        "label": "Full access"            },
      { "value": "read-only",  "label": "Read-only access"       },
      { "value": "stats-only", "label": "Stats-only access"      },
      { "value": "no",         "label": "Do not allow access"    },
    ];
  }

  // Functions to prevent users from downgrading their own user permissions w/o confirmation.

  _onFormSubmit(e) {
    if ( this.state.downgrading_self ) return true;

    const thisUser = this.props.entity;
    const currentUser = this.props.library.current_user;
    const isEditingSelf = thisUser && currentUser && thisUser.id && currentUser.id && thisUser.id === currentUser.id;

    if ( !isEditingSelf ) return true;

    const isDisabled = $("input[name='eng_user[is_disabled]']").is(":checked");
    const permissionUi = $("select[name='eng_user[permission_ui]']").val();

    const isDangerousOperation = isDisabled || permissionUi !== "yes";

    if ( !isDangerousOperation ) return true;

    e.preventDefault();
    e.stopPropagation();

    this.setState({
      downgrading_self: true,
    });

    return false;
  }

  _doFormSubmit() {
    $("form").submit();
  }

  _stopDowngradingSelf() {
    this.setState({
      downgrading_self: false,
    });
  }

}

export default EuiUsersForm;
